import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

type Response = components["schemas"]["MacFastestGrowingItemsModel"][];

export type FastestGrowingItem = components["schemas"]["FastestGrowingItem"];
export type MacFastestGrowingItemsModel = components["schemas"]["MacFastestGrowingItemsModel"];

export interface FastestGrowingKeywordsData {
    items: MacFastestGrowingItemsModel[];
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get fastest growing macs';

const transformData = (data: Response = []): FastestGrowingKeywordsData => ({
    items: data ?? []
});

async function getFastestGrowingKeywords(): Promise<FastestGrowingKeywordsData> {
    try {
        const response: Response = await http.get(REQUEST_TYPE);

        return transformData(response);
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return transformData();
    }
}

export function useFastestGrowingKeywords() {
    return useData(transformData(), getFastestGrowingKeywords);
}
